export default class Customization {

    constructor(Rest) {
        this.rest = Rest.rest;
    }

    storeGroup(name) {
        return this.rest.all('customization/group').post({ name: name });
    };

    storeField(groupId, name, type) {
        return this.rest.all('customization/group/' + groupId + '/field').post({ name: name, type: type });
    };

    updateGroup(group) {
        return this.rest.one('customization').one('group', group.id).customPUT({
            name: group.name,
            historical: group.historical
        });
    };

    updateField(group, field) {
        return this.rest.one('customization').one('group', group.id).one('field', field.id).customPUT({
            name: field.name,
            type: field.type
        });
    };

    findGroup(id) {
        return this.rest.one('customization').one('group', id).get({ 'includes[]': 'fields' });
    };

    removeField(groupId, id) {
        return this.rest.one('customization/group/' + groupId + '/field/' + id).remove();
    };

    fieldFilters(groupId, id) {
        return this.rest.one('customization/group/' + groupId +'/field/' + id + '/segments').get();
    };

    removeGroup(group) {
        return this.rest.one('customization/group/' + group.id).remove();
    };

    allGroups() {
        return this.rest.one('customization/group').get({
            pagination: false,
            'includes[]': 'fields'
        });
    };

    updateFieldData(attributes) {
        return this.rest.one('customization').one('data').customPUT(attributes);
    };

    updateOptionsToMultiple(groupId, fieldId, data, action) {
        return this.rest.all('customization/updateOptionsToMultiple').post({
            groupId: groupId,
            fieldId: fieldId,
            data: data,
            action: action
        });
    };

    searchOptions(fieldId, groupId, fieldName) {
        return this.rest.one('customization').one('group', groupId).one('field', fieldId).one('options').get({ name: fieldName });
    };

    getOptionsByFieldIdAndPositions(fieldId, groupId, positions) {
        return this.rest.one('customization').one('group', groupId).one('field', fieldId).one('options').get({ positions: positions });
    };

    getPreferenceList() {
        return new Promise((resolve, reject) => {
            this.getPreferenceGroups().then(groups => {
                if (!groups || !groups.length) {
                    return resolve([]);
                }
                var requests = groups.map(group => this.getPreferences(group.id).catch(() => []));
                var preferencesList = [];
                Promise.all(requests).then(list => {
                    groups.forEach((group, index, groupsArray) => {
                        let sameNameGroups = groupsArray.filter(groupItem => groupItem.name === group.name);
                        let uniqueGroupName = group.name;
                        if (sameNameGroups.length > 1) {
                            let groupNameIndex = sameNameGroups.indexOf(group);
                            if (index > 0) {
                                uniqueGroupName = `${group.name}(${groupNameIndex})`;
                            }
                        }
                        preferencesList = preferencesList.concat(list[index].map(preference => {
                            preference.groupName = uniqueGroupName;
                            return preference;
                        }));
                    });
                    resolve(preferencesList, groups);
                });
            }).catch(err => reject(err));
        });
    }

    getPreferenceGroups() {
        return this.rest.one('preference-groups').get().then(({ data }) => data);
    }

    getPreferences(preference_group_id) {
        return this.rest.one('preference-group', preference_group_id).one('preferences').get();
    }
};
